import axios from "axios";
import { saveAs } from "file-saver";
import api from "../../../Services/api";
import stablesApi from "../../../Services/stablesApi";

/** URL do comprovante PDF — aceita camelCase ou snake_case da API */
export const getReceiptUrl = (item) =>
  item?.receiptUrl || item?.receipt_url || item?.comprovanteUrl || null;

export const downloadStablesReceipt = async (item) => {
  const receiptUrl = getReceiptUrl(item);

  if (!receiptUrl) {
    throw new Error("RECEIPT_URL_MISSING");
  }

  const isAbsolute = /^https?:\/\//i.test(receiptUrl);
  const isStablesPath = receiptUrl.startsWith("/v1/stables");
  const client = isAbsolute ? axios : isStablesPath ? stablesApi : api;

  const { data } = await client.get(receiptUrl, { responseType: "blob" });
  const blob = new Blob([data], { type: "application/pdf" });
  saveAs(blob, `comprovante-stables-${item.id ?? item.transactionId}.pdf`);
};
